export class Skill {    
  name:string;
  isNew:boolean = false;

  constructor(name = ""){
    if(name)
      this.name = name;
  }
}
